const escapeFormulaString = (value: string) => value.replace(/"/g, '\\"');

export const airtableFormulas = {
  calendar: {
    upcoming: "{Date} > NOW()",
  },
  bookings: {
    byEducatorEmail: (email: string) =>
      `LOWER(TRIM(ARRAYJOIN({Educator E-mail Address}))) = LOWER("${escapeFormulaString(email)}")`,
  },
  responses: {
    byBookingIdInName: (bookingId: string) =>
      `LOWER(TRIM({Name})) = LOWER("${escapeFormulaString(bookingId)}")`,
  },
};
